import {observer} from 'mobx-react'
import Transition from 'react-transition-group/Transition'
import CONTENT from '../stores/Content'
import UI from '../stores/UI'
import Markdown from '../components/Markdown'
import IntroPadding from '../components/IntroPadding'

class AboutPage extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false
    }
  }

  componentWillMount() {
    CONTENT.fetchHomepage()
    UI.toggleIntroPadding(false)
  }

  componentDidMount() {
    this.setState({
      show: true
    })
  }

  render() {

    const duration = 300;

    const transitionStyles = {
      entering: { opacity: 0 },
      entered:  { opacity: 1 },
    };

    const hasContent = CONTENT.aboutCopy ? true : false;

    return (
      <Transition in={this.state.show && hasContent} timeout={duration}>
        {(state) => (
          <div className="fs" style={{
            transition: `opacity ${duration}ms ease-in-out`,
            opacity: 0,
            ...transitionStyles[state]
          }}>
            <IntroPadding />
            <div className="fs txt-c innerx8 page-top">
              <div className="max--skinny middle guttersx2">
                <Markdown convert={CONTENT.aboutCopy} />
              </div>
            </div>
            <div className="footer-label txt-c padx4 pabs--b">
              <p>{CONTENT.copyright}</p>
            </div>
          </div>
        )}
      </Transition>
    )
  }
}

export default observer(AboutPage)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/AboutPage.js